import React from "react";
import { FaFacebook, FaWhatsapp, FaInstagram, FaPhone, FaMapMarkerAlt, FaClock, FaLinkedin } from "react-icons/fa";
import { SiX } from 'react-icons/si';
import logo from '../Assets/Logo/Kiaan-Logo-1-1.png';

export default function Footer() {
  const date = new Date();
  const currentYear = date.getFullYear();
  
  return (
    <footer className="bg-customGreen text-white py-8">
      <div className="container mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row justify-between items-start space-y-8 md:space-y-0">
          
          {/* Logo and Contact Information */}
          <div className="w-full md:w-1/3">
            <img src={logo} className="h-12 mb-6" alt="Kiaan AgrowTech Logo" />
            <div className="space-y-2">
              <p className="flex items-center">
                <FaClock className="mr-2" /> Open Hours: Mon - Fri: 9.00 am to 6.00 pm.
              </p>
              <p className="flex items-center">
                <FaMapMarkerAlt className="mr-2" /> 18, 3rd Cross, BEML Layout, 5th Stage,
              </p>
              <p>(Behind Swarga Rani School), Rajarajeshwari Nagar,</p>
              <p>Bengaluru - 560098.</p>
              <p className="flex items-center mt-4">
                <FaPhone className="mr-2" /> +918618944125
              </p>
            </div>
            <div className="flex space-x-4 mt-6">
              {/* <a href="https://www.facebook.com" aria-label="Facebook" target="_blank" rel="noopener noreferrer" className="text-white hover:text-green-500 transition duration-300">
                <FaFacebook size={24} />
              </a> */}
              <a href="https://wa.me/+918618944125?text=Hello%20there" aria-label="WhatsApp" target="_blank" rel="noopener noreferrer" className="text-white hover:text-green-500 transition duration-300">
                <FaWhatsapp size={24} />
              </a>
              <a href="https://x.com/kiaanagrow?t=hQA1htSHHpGGHtHcTR3KtA&s=08" aria-label="X (formerly Twitter)" target="_blank" rel="noopener noreferrer" className="text-white hover:text-green-500 transition duration-300">
                <SiX size={24} />
              </a>
              <a href="https://www.instagram.com/kiaan.agrowtech?igsh=cDJsMmZqOThleWxx" aria-label="Instagram" target="_blank" rel="noopener noreferrer" className="text-white hover:text-green-500 transition duration-300">
                <FaInstagram size={24} />
              </a>
              <a href="https://www.linkedin.com/company/kiaanagrowtech/posts/?feedView=all" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="text-white hover:text-green-500 transition duration-300">
                <FaLinkedin size={24} />
              </a>
            </div>
          </div>

          {/* Farming Partnership */}
          <div className="w-full md:w-1/3">
            <h4 className="text-xl font-semibold mb-4">Farming Partnership</h4>
            <ul className="space-y-2">
              <li>
                <a href="#about" className="hover:text-green-500 transition duration-300">Our Story</a>
              </li>
              <li>
                <a href="#partnership" className="hover:text-green-500 transition duration-300">How It Works</a>
              </li>
              <li>
                <a href="#economics" className="hover:text-green-500 transition duration-300">Partnership Economics</a>
              </li>
              <li>
                <a href="#projects" className="hover:text-green-500 transition duration-300">Project Photos</a>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="w-full md:w-1/3">
            <h4 className="text-xl font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#home" className="hover:text-green-500 transition duration-300">Home</a>
              </li>
              <li>
                <a href="#about" className="hover:text-green-500 transition duration-300">About Us</a>
              </li>
              <li>
                <a href="#contact" className="hover:text-green-500 transition duration-300">Become a Partner</a>
              </li>
            </ul>
            <p className="text-sm text-gray-400 mt-6 font-serif italic">
              "Be Part of the Farm. Be Part of the Harvest."
            </p>
          </div>
        </div>

        <div className="text-center border-t border-gray-600 mt-8 pt-4">
          <p>© Copyright {currentYear} Kiaan AgrowTech Pvt Ltd. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
